import type { PlatformAdapter, ThemeParams } from './types';

const MOCK_THEME: ThemeParams = {
  bg_color: '#ffffff',
  text_color: '#000000',
  button_color: '#3390ec',
  button_text_color: '#ffffff',
};

export const MOCK_ADAPTER: PlatformAdapter = {
  platform: 'browser',
  apiPlatform: null,

  getInitData(): string {
    return 'mock_auth_token';
  },

  showBackButton(onClick: () => void): void {
    console.log('[MOCK] showBackButton', onClick);
  },

  hideBackButton(): void {
    console.log('[MOCK] hideBackButton');
  },

  setMainButton(label: string, onClick: () => void): void {
    console.log('[MOCK] setMainButton', label, onClick);
  },

  hideMainButton(): void {
    console.log('[MOCK] hideMainButton');
  },

  close(): void {
    console.log('[MOCK] close');
  },

  hapticImpact(style?: 'light' | 'medium' | 'heavy'): void {
    console.log('[MOCK] hapticImpact', style);
  },

  hapticNotification(type: 'success' | 'error' | 'warning'): void {
    console.log('[MOCK] hapticNotification', type);
  },

  getThemeParams(): ThemeParams {
    return MOCK_THEME;
  },

  share(text: string, url?: string): void {
    console.log('[MOCK] share', text, url);
  },

  openExternal(url: string): void {
    console.log('[MOCK] openExternal', url);
    window.open(url, '_blank', 'noopener,noreferrer');
  },

  getStartParam(): string | undefined {
    return new URLSearchParams(window.location.search).get('start_param') ?? undefined;
  },

  disableVerticalSwipes(): void {
    console.log('[MOCK] disableVerticalSwipes');
  },

  ready(): void {
    console.log('[MOCK] ready');
  },

  expand(): void {
    console.log('[MOCK] expand');
  },

  getViewportStableHeight(): number | null {
    return null;
  },

  onViewportChanged(cb: (isStateStable: boolean) => void): () => void {
    console.log('[MOCK] onViewportChanged', cb);
    return () => {};
  },

  capabilities: { nativeBackButton: false, fileUpload: true } as const,
};
